<template>
  <div class="sp-template">
    <div class="h-title">提现</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
      <el-form ref="withdrawForm" :model="withdrawForm" label-width="80px">
        <el-form-item label="付款组织">
          <h3 class="sub-title">深圳市星邮供应链管理有限公司</h3>
        </el-form-item>
        <el-form-item label="提现币种">
          <el-radio-group v-model="withdrawForm.currency">
            <el-radio label="人民币"></el-radio>
            <!-- <el-radio label="美元"></el-radio> -->
          </el-radio-group>
        </el-form-item>
        <el-form-item label="提现金额">
          <el-input v-model.lazy="withdrawForm.amount" placeholder="提现金额" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="开户名">
          <el-input v-model.lazy="withdrawForm.accountName" placeholder="开户名" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="提现银行">
          <el-input v-model.lazy="withdrawForm.bankName" placeholder="提现银行" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="提现账号">
          <el-input v-model.lazy="withdrawForm.account" placeholder="提现账号" size="medium"></el-input>
        </el-form-item>
        <div class="tips-content">
          <h3 class="sub-title">温馨提示</h3>
          <ul class="tips">
            <li>1、通过信用卡的快捷支付有500元限制；超过500元时您可以选择其它方式支付；</li>
            <li>2、如您有欠费账单，充值后会优先补扣欠费账单；</li>
            <li>3、充值后请及时对支付订单进行结算，以免影响正常服务。</li>
          </ul>
        </div>
        <el-form-item>
          <el-button size="small" type="primary">提现</el-button>
          <el-button size="small">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      withdrawForm: {
        org: "深圳市星邮供应链管理有限公司",
        currency: "人民币",
        amount: "",
        accountName: "",
        bankName: "",
        account: ""
      }
    };
  },
  components: {},
  created() {},
  computed: {},
  methods: {
    //分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.sub-title {
  color: #646464;
  font-size: 14px;
}
.tips-content {
  margin-top: 30px;
  margin-bottom: 30px;
  .tips li {
    margin-top: 10px;
    color: #606266;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/withdraw/withdraw.vue